import { User } from '../../contexts/AuthContext/authContext.types';

export function isTrialAccess(user?: User, dataset?: string): boolean {
  if (!user) return true;
  if (user.isTrialUser) return true;

  if (dataset && user.accessRoles) {
    if (dataset === 'Private' || dataset === 'SEC') {
      return user.accessRoles?.includes('ROLE_TRIAL_COMPID');
    } else if (dataset === 'Public') {
      return user.accessRoles?.includes('ROLE_TRIAL_GLOBAL');
    } else if (dataset === 'Both') {
      return (
        user.accessRoles?.includes('ROLE_TRIAL_COMPID') ||
        user.accessRoles?.includes('ROLE_TRIAL_GLOBAL')
      );
    } else {
      return (
        user.accessRoles?.includes('ROLE_TRIAL_COMPID') ||
        user.accessRoles?.includes('ROLE_TRIAL_GLOBAL')
      );
    }
  }

  return user.isTrialUser;
}

export function hasBenchwiseAccess(user?: User): boolean {
  if (!user) {
    return false;
  }
  return user.accessRoles?.includes('ROLE_BENCHWISE_USER') || false;
}

export function hasAdminAccess(user?: User): boolean {
  if (!user) {
    return false;
  }
  return user.isAdminUser ? user.isAdminUser : false;
}
